import { OptionLike } from "helpers/OptionHelper";
import { BaseModel } from "./BaseModel";
import { ExemptionMotiveData } from "./types";

export class ExemptionMotive extends BaseModel<ExemptionMotiveData> {
	id: string;
	name: string;
	code: string;
	description: string;

	constructor(data: ExemptionMotiveData) {
		super(data);
		this.id = data.id;
		this.name = data.name;
		this.code = data.code;
		this.description = data.description;
	}

	toOption = (): OptionLike & ExemptionMotive => {
		return { ...this, label: `${this.code} - ${this.name}`, value: this.id };
	};
}
